<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import AgentAnalytics from "@/components/AgentAnalytics.vue";
</script>

<template>
  <AgentLayout>
    <AgentAnalytics />
  </AgentLayout>
</template>
